module.exports = __webpack_public_path__ + "img/shadow.456f7a33.png";